// @flow
import { type TrackingData } from 'app/common/lib/react/analytics';
import { type VideoContextLogData } from 'app/packages/pinterest-flow-types/video';

// This type is a strict subset of VideoEventData fields in event_if.thrift.
// It is the old video logging format that is still in use today.
export type VideoEventData = {|
  videoDuration: number,
  time: number,
  endTime: number,
  videoTime: number,
  endVideoTime: number,
  isAudible: boolean,
  height: number,
  width: number,
  playbackState: $Values<typeof PCONST.thrift.VideoPlaybackState>,
  quartile: number,
  quartilePercentValue: number,
  windowHeight: number,
  windowWidth: number,
  viewability: number,
|};

/*
 * Adapt v2 format context log payload to v1 format.
 *
 * This is temporarily needed because API layer and back-end hive workflow do
 * not fully support reading v2 formatted context log payloads. When we migrate
 * everything to recognize v2, we should be able to delete this code.
 */
export default function videoLogV2ToV1Adapter(data: VideoContextLogData): TrackingData {
  const {
    eventData: {
      videoEvent: {
        videoDuration,
        startTime,
        endTime,
        videoStartTime,
        videoEndTime,
        isAudible,
        height,
        width,
        playbackState,
        quartile,
        quartilePercentValue,
        windowHeight,
        windowWidth,
        viewability,
      },
    },
    ...rest
  } = data;
  return {
    ...rest,
    eventData: {
      videoEventData: {
        videoDuration,
        time: startTime,
        endTime,
        videoTime: videoStartTime,
        endVideoTime: videoEndTime,
        isAudible,
        height,
        width,
        playbackState,
        quartile,
        quartilePercentValue,
        windowHeight,
        windowWidth,
        viewability,
      },
    },
  };
}
